import { apiClient } from '../../../../helpers/api_helper';

export const getAllOldGoldPurchaseRateData = async (fromDate: any, toDate: any, data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/Rate/GetOldGoldPurchaseRateList?FromDate=${fromDate}&ToDate=${toDate}`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const createOldGoldPurchaseRate = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/Rate/InsertGoldPurchaseRate', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const updateOldGoldPurchaseRate = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/Rate/UpdateOldGoldPurchaseRate', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const deleteOldGoldPurchaseRate = async (id: any) => {
    try {
        const response = await apiClient.delete(`/api/v1/Rate/DeleteOldGoldPurchaseRate?Id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};